// Raftor WebHQ: render item badges on grid and list product cards

frappe.ready(() => {
  if (typeof frappe === "undefined" || !frappe.call) return;
	const isAllProductsPage = window.location && window.location.pathname === "/all-products";
	const isItemGroupListing = Boolean(document.querySelector('.item-group-content[data-item-group]'));
	const hasListingRoot = Boolean(document.getElementById("product-listing"));
	if (!isAllProductsPage && !isItemGroupListing && !hasListingRoot) {
		return;
	}

  function getCardNode(el) {
    return el?.closest?.(".item-card, .list-row") || null;
  }

  // Codes already fetched (successfully or not) -- the three fixed-delay
  // setTimeouts below plus every webhqDom.onAdded mutation firing were each
  // independently re-collecting and re-fetching the FULL current item-code
  // set with no memory of previous calls, so a 24-card page fired this same
  // endpoint 9 times with a near-identical payload every time (found live
  // via a full network trace -- one of several near-identical per-card
  // "enrichment" scripts doing this). Tracking what's already been
  // requested turns the fixed retries into harmless no-ops once the first
  // one succeeds, while still correctly picking up genuinely NEW cards
  // (infinite scroll, filter re-render) on the next trigger.
  const requestedCodes = new Set();
  let fetchInFlight = false;
  let refetchQueued = false;

  function injectBadges() {
    const root = document.getElementById("product-listing");
    if (!root) return;

    const itemCodeEls = root.querySelectorAll("[data-item-code]");
    if (!itemCodeEls.length) return;

    // Collect unique item codes from any element that has data-item-code
    const codeSet = new Set();
    itemCodeEls.forEach((el) => {
      const code = el.getAttribute("data-item-code");
      if (code) codeSet.add(code);
    });

    const itemCodes = Array.from(codeSet).filter((code) => !requestedCodes.has(code));
    if (!itemCodes.length) return;

    if (fetchInFlight) {
      refetchQueued = true;
      return;
    }
    fetchInFlight = true;
    itemCodes.forEach((code) => requestedCodes.add(code));

    frappe.call({
      method: "raftor_webhq.catalog.api.get_item_badges",
      args: { item_codes: itemCodes },
      callback: (r) => {
        fetchInFlight = false;
        if (refetchQueued) {
          refetchQueued = false;
          injectBadges();
        }

        const mapping = (r && r.message) || {};
        if (!mapping || typeof mapping !== "object") return;

        itemCodes.forEach((code) => {
          const badges = mapping[code] || [];
          if (!badges.length) return;

          // For each occurrence of this item on the page, decorate the card
          root
            .querySelectorAll(`[data-item-code="${CSS.escape(code)}"]`)
            .forEach((el) => {
              const cardRoot = getCardNode(el);
              const card = cardRoot?.querySelector?.(".card") || cardRoot;
              const cardBody = card?.querySelector?.(".card-body") || card;
              if (!card || !cardBody) return;

              // Avoid duplicate injection
              if (card.querySelector(".ce-badges")) return;

              const container = document.createElement("div");
              container.className = "ce-badges";

              badges.forEach((b) => {
                const span = document.createElement("span");
                const type = (b.badge_type || "").toString();
                const slug = type.toLowerCase().replace(/[^a-z0-9]+/g, "-");
                span.className = `ce-badge ce-badge-${slug}`;
                span.textContent = (b.label || type).toString();
                container.appendChild(span);
              });

              card.insertBefore(container, card.firstChild);
            });
        });
      },
    });
  }

  // Initial tries (listing renders asynchronously)
  setTimeout(injectBadges, 600);
  setTimeout(injectBadges, 1500);
  setTimeout(injectBadges, 3000);

  // Re-run after infinite scroll appends items
  document.addEventListener('products-loaded', function () {
    setTimeout(injectBadges, 50);
  });

  // Observe listing updates (filters/paging re-render)
  const root = document.getElementById("product-listing");
  if (root) {
    let timer = null;
    window.webhqDom.onAdded((roots) => {
      const touchesListing = roots.some((r) => r === root || root.contains(r) || r.contains(root));
      if (!touchesListing) return;
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(injectBadges, 400);
    });
  }
});
